// extracted by mini-css-extract-plugin
export var parcelRow = "_tp-0";